import i18n from 'i18next';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { SlideInterface } from '@tencent/docs-api';
import {
    IElementNode,
    ISlideNode,
    ITextElementBoxNode,
} from '../../slide-content-enumerator/enumerator-types.interface';
import { TextOverlapBaseAnalyzer } from '../../slide-rating-and-improve/text/text-overlap/text-overlap-base-analyzer';
import { BaseAnalyzer } from '../base/base-analyzer';

interface IOverlapElement {
    pageIndex?: number,
    element?: IElementBaseModel,
    back?: IElementBaseModel,
}

type IResult = SlideInterface.CheckResultItem;

export class MachineOverlapAnalyzer extends BaseAnalyzer<IResult> {
    private title = i18n.t('元素重叠检测');
    private description = i18n.t('检查文字是否重叠、图形是否遮挡文字');
    private level = 'warning' as const;
    private anchorType = 'element' as const;

    private overlapAnalyzer: TextOverlapBaseAnalyzer; // vips算法布局信息检测
    private overlapElements = new Map<string, IOverlapElement>();

    public constructor(private uiDataService: IUiDataService) {
        super();
        this.overlapAnalyzer = new TextOverlapBaseAnalyzer();
        this.overlapAnalyzer.onOverlapDetected = (textNode, backNode) => {
            const pageIndex = textNode.data?.slideNode.slideIndex;
            const element = textNode.data?.element;
            if  (element?.id) {
                this.overlapElements.set(element.id, { pageIndex, element, back: backNode.data?.element });
            }
        };
    }

    public onPresentationStart(): void {
        this.overlapAnalyzer.resetWithPresentation(this.uiDataService.presentation);
        this.overlapElements = new Map<string, IOverlapElement>();
    }

    public onSlideEnd(slide: ISlideNode): void {
        this.overlapAnalyzer.onSlideEnd(slide);
    }

    public onElement(element: IElementNode): void {
        this.overlapAnalyzer.checkNewElement(element, true);
    }

    public onTextElementBox(textElementBoxNode: ITextElementBoxNode): void {
        this.overlapAnalyzer.checkNewTextElementBoxNode(textElementBoxNode);
    }

    public async calculateResult(): Promise<IResult> {
        const passed = this.overlapElements.size <= 0;
        if (passed) {
            return { passed, title: this.title, description: this.description };
        }
        const errorArray = Array.from(this.overlapElements.values());
        const errorMessages: SlideInterface.CheckErrorMessage[] = errorArray.map(item => ({
            level: this.level,
            anchorType: this.anchorType,
            anchor: item.element,
            description: i18n.t(`元素[${item.element?.name}]和其他文字区域有重叠`),
        }));
        return { passed, title: this.title, description: this.description, errorMessages };
    }
}
